import React, { FC, useCallback, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { UserClientTypeRequestDto } from '@sparling/financial-common'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { InputField } from '../../../../../components/Dashboard/InputField'
import { Modal } from '../../../../../components/Dashboard/Modal'
import { InputSelect } from '../../../../../components/Dashboard/InputSelect'
import { clientTypesForAssignToUserLoading, getClientTypesForAssignToUserEnum } from '../../../../../store/selectors'
import { userClientTypeRequest } from '../../../../../store/actions'
import { Loader } from '../../../../../components/Loader'

interface IApplyNewClientTypeModalProps {
  isOpen: boolean
  modalClose: () => void
  currentClientType?: string | null
  currentClientTypeId?: string | null
}

export const ApplyNewClientTypeModal: FC<IApplyNewClientTypeModalProps> = ({
  isOpen,
  modalClose,
  currentClientType,
  currentClientTypeId,
}) => {
  const dispatch = useDispatch()
  const clientTypesForAssignToUser = useSelector(getClientTypesForAssignToUserEnum)
  const loading = useSelector(clientTypesForAssignToUserLoading)
  const formMethods = useForm<UserClientTypeRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(UserClientTypeRequestDto),
  })
  const {
    handleSubmit,
    formState: { isValid },
    register,
  } = formMethods

  const onSubmit = useCallback(
    async (data) => {
      dispatch(userClientTypeRequest(data))
      modalClose()
    },
    [dispatch, modalClose],
  )

  const filteredEnums = useMemo(
    () => clientTypesForAssignToUser.filter((ct) => ct.value !== currentClientTypeId),
    [clientTypesForAssignToUser, currentClientTypeId],
  )

  return (
    <Modal
      title="Update Client Type"
      submitTitle="Apply"
      isOpen={isOpen}
      modalClose={modalClose}
      isSubmit
      isSubmitDisabled={!isValid}
      onSubmit={handleSubmit(onSubmit)}
    >
      {loading && <Loader />}
      <FormProvider {...formMethods}>
        <Grid container spacing={3} marginBottom={4}>
          <Grid item xs={12}>
            <InputField
              inputName="currentTypeName"
              labelName="Current Type"
              inputType="text"
              width="100%"
              defaultValue={currentClientType ?? ''}
              disabled
            />
            <input type="hidden" {...register('currentType')} value={currentClientTypeId ?? ''} />
          </Grid>
          <Grid item xs={12}>
            <InputSelect inputName={'newType'} labelName="New Type" width="100%" enums={filteredEnums} />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
